import { atomWithStorage } from 'jotai/utils';

const userAtom = atomWithStorage('user', null);

export default userAtom;
